import { combineReducers } from "redux"
import brand from './brand';
import currentUser from "./currentUser"
import dashboard from './dashboard'
import errors from "./errors"
import messages from "./messages"
import files from "./files"
import exercises from './exercises';
import instructions from './instructions';
import exerciseCats from './exerciseCats';
import workoutCats from './workoutCats';
import workouts from './workouts';
import equipment from './equipment';
import blocks from './blocks';
import blockCats from './blockCats';
import instructionCats from './instructionCats';
import programCats from './programCats';
import programs from './programs';
import groups from './groups';
import clients from './clients';
import assignments from './assignments';
import partners from './partners';
import categories from './categories';
import statements from './statements';
import invoices from './invoices';
import loader from './loader';
import alert from './alert';
import payments from './payments';
import products from './products';
import automations from './automations';

const rootReducer = combineReducers({
  brand,
  currentUser,
  dashboard,
  errors,
  loader,
  messages,
  files,
  exercises,
  exerciseCats,
  workoutCats,
  workouts,
  equipment,
  blockCats,
  blocks,
  instructionCats,
  programCats,
  programs,
  groups,
  clients,
  assignments,
  partners,
  categories,
  statements,
  alert,
  payments,
  invoices,
  products,
  instructions,
  automations
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js